import Script from 'next/script'
import invariant from 'tiny-invariant'

const appId = process.env.NEXT_PUBLIC_FACEBOOK_SDK_APP_ID

invariant(appId, 'NEXT_PUBLIC_FACEBOOK_SDK_APP_ID is not set in FacebookSDK')

export const FacebookSDK = () => {
  if (process.env.NEXT_PUBLIC_ENABLE_ANALYTICS !== 'true') {
    return null
  }

  if (!appId) {
    return null
  }

  return (
    <>
      <Script
        id="facebook-sdk-script-init"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
              window.fbAsyncInit = function() {
                FB.init({
                  appId            : '${appId}',
                  autoLogAppEvents : true,
                  xfbml            : true,
                  version          : 'v11.0'
                });
              };
            `,
        }}
      />
      <Script
        id="facebook-sdk-script"
        strategy="lazyOnload"
        crossOrigin="anonymous"
        src="https://connect.facebook.net/en_US/sdk.js"
      />
    </>
  )
}
